import { render, staticRenderFns } from "./soanVanBanDen.vue?vue&type=template&id=edb75292&"
import script from "./soanVanBanDen.vue?vue&type=script&lang=js&"
export * from "./soanVanBanDen.vue?vue&type=script&lang=js&"
import style0 from "./soanVanBanDen.vue?vue&type=style&index=0&lang=css&"
import style1 from "./soanVanBanDen.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports